
import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function UKPNReactive() {
  const sigClientRef = useRef(null);
  const sigEngineerRef = useRef(null);
  const [form, setForm] = useState({
    customerName: "",
    jobNumber: "",
    site: "",
    engineer: "",
    date: "",
    telNo: "",
    timeOn: "",
    timeOff: "",
    description: "",
    clientSignature: "",
    engineerSignature: "",
    materialsUsed: "",
    callOut: "",
    labour: "",
    materials: "",
    total: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const clearClientSignature = () => {
    sigClientRef.current.clear();
    setForm(prev => ({ ...prev, clientSignature: "" }));
  };
  const saveClientSignature = () => {
    if (!sigClientRef.current.isEmpty()) {
      setForm(prev => ({ ...prev, clientSignature: sigClientRef.current.getTrimmedCanvas().toDataURL("image/png") }));
    }
  };
  const clearEngineerSignature = () => {
    sigEngineerRef.current.clear();
    setForm(prev => ({ ...prev, engineerSignature: "" }));
  };
  const saveEngineerSignature = () => {
    if (!sigEngineerRef.current.isEmpty()) {
      setForm(prev => ({ ...prev, engineerSignature: sigEngineerRef.current.getTrimmedCanvas().toDataURL("image/png") }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("UKPN Reactive Form submitted!");
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4 position-relative">
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            UKPN Reactive Form
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* 1st row: 3 columns */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Customer Name</label>
                <input type="text" className="form-control" name="customerName" value={form.customerName} onChange={handleChange} required placeholder="Customer Name" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Job Number</label>
                <input type="text" className="form-control" name="jobNumber" value={form.jobNumber} onChange={handleChange} required placeholder="Job Number" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Site</label>
                <input type="text" className="form-control" name="site" value={form.site} onChange={handleChange} required placeholder="Site" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>

              {/* 2nd row: 3 columns */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Engineer</label>
                <input type="text" className="form-control" name="engineer" value={form.engineer} onChange={handleChange} required placeholder="Engineer" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Date</label>
                <input type="date" className="form-control" name="date" value={form.date} onChange={handleChange} required style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Tel No</label>
                <input type="text" className="form-control" name="telNo" value={form.telNo} onChange={handleChange} required placeholder="Tel No" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>

              {/* 3rd row: 2 columns */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Time On</label>
                <input type="time" className="form-control" name="timeOn" value={form.timeOn} onChange={handleChange} required style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Time Off</label>
                <input type="time" className="form-control" name="timeOff" value={form.timeOff} onChange={handleChange} required style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>

              {/* Description of Works */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Description of Works</label>
                <textarea className="form-control" name="description" value={form.description} onChange={handleChange} required placeholder="Description of Works" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} rows={3} />
              </div>

              {/* Signatures */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Client Signature</label>
                <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', minHeight: '120px', position: 'relative' }}>
                  <SignatureCanvas ref={sigClientRef} penColor="#8b1634" backgroundColor="#e9cfd6" clearOnResize={false} velocityFilterWeight={0.7} minWidth={1} maxWidth={2.5} dotSize={1.5} throttle={16} canvasProps={{ width: 350, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }} onEnd={saveClientSignature} />
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                    <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }} onClick={clearClientSignature}>Clear</button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Engineer Signature</label>
                <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', minHeight: '120px', position: 'relative' }}>
                  <SignatureCanvas ref={sigEngineerRef} penColor="#8b1634" backgroundColor="#e9cfd6" clearOnResize={false} velocityFilterWeight={0.7} minWidth={1} maxWidth={2.5} dotSize={1.5} throttle={16} canvasProps={{ width: 350, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }} onEnd={saveEngineerSignature} />
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                    <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }} onClick={clearEngineerSignature}>Clear</button>
                  </div>
                </div>
              </div>

              {/* Materials Required */}
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Materials Required</label>
                <textarea className="form-control" name="materialsUsed" value={form.materialsUsed} onChange={handleChange} required placeholder="Materials Used" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} rows={2} />
              </div>

              {/* Materials / Labour Section */}
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">Materials / Labour</label>
              </div>
              <div className="col-md-3">
                <input type="text" className="form-control" name="callOut" value={form.callOut} onChange={handleChange} required placeholder="Call Out" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-3">
                <input type="text" className="form-control" name="labour" value={form.labour} onChange={handleChange} required placeholder="Labour" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-3">
                <input type="text" className="form-control" name="materials" value={form.materials} onChange={handleChange} required placeholder="Materials" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              <div className="col-md-3">
                <input type="text" className="form-control" name="total" value={form.total} onChange={handleChange} required placeholder="Total" style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>

              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2" style={{ backgroundColor: "#8b1634", borderRadius: "30px", boxShadow: "0 4px 12px rgba(139,22,52,0.3)" }}>
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UKPNReactive;
